import React, { useContext } from 'react';
import clsx from 'clsx';

import { AccountDataContext } from 'modules/context';
import { ArrowSpinnerColour } from 'components/Spinner/constants';
import { ButtonColour, ButtonStyle } from 'components/Button/constants';
import { EventsActions, EventsCategories } from 'modules/gtm/constants';
import { isITIL } from 'modules/utils/utils';
import { ReactComponent as ITILSvg } from 'modules/theme/ims/ITIL-logo.svg';
import { TriggerGTMEvent } from 'modules/gtm';
import { useMaturityModelsAccess } from './useMaturityModelsAccess';
import * as Button from 'components/Button';
import CtaButton from 'components/Cta/Button';
import Spinner from 'components/Spinner';

import styles from './styles.module.scss';

type ITILProps = {
  CTALabel?: string;
  CTALink?: string;
  description?: string;
  isDashboard: boolean;
  title?: string;
};

const ITIL: React.FunctionComponent<ITILProps> = ({
  CTALabel,
  CTALink,
  description,
  isDashboard,
  title,
}) => {
  const { redirectToMMPlatform, gettingMMAccess } = useMaturityModelsAccess();
  const classNames = clsx(
    styles.maturityModelItem,
    styles.itil,
    gettingMMAccess && styles.loading,
  );
  const { accountDataContext } = useContext(AccountDataContext);

  const handleClick = () => {
    TriggerGTMEvent({
      action: EventsActions.CLICK_VISIT_MM_ITIL,
      category: EventsCategories.MATURITY_MODEL,
      label: '',
    });
    if (!isITIL(accountDataContext)) {
      redirectToMMPlatform();
    }
  };

  return (
    <section className={classNames}>
      <h3>{title || 'Axelos maturity model application'}</h3>
      <p
        dangerouslySetInnerHTML={{
          __html:
            description ||
            "Carry out assessments easily, view your consultancy's activity, request certifications and view reports.",
        }}
      ></p>
      <div>
        <ITILSvg />
        <div>
          {!isITIL(accountDataContext) && isDashboard ? (
            <Button.Generic
              ariaLabel={CTALabel}
              colour={ButtonColour.BRAND_BLACK_GRAPE}
              disabled={gettingMMAccess}
              label={CTALabel}
              onClick={handleClick}
              small
              style={ButtonStyle.PRIMARY}
            >
              {gettingMMAccess && (
                <Spinner
                  background={false}
                  className={styles.spinner}
                  colour={ArrowSpinnerColour.WHITE}
                />
              )}
            </Button.Generic>
          ) : (
            <CtaButton
              custom_url={CTALink}
              defaultColour={ButtonColour.BRAND_BLACK_GRAPE}
              label={CTALabel}
              onClick={handleClick}
              style={ButtonStyle.PRIMARY}
              small
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default ITIL;
